import * as React from 'react';

import SearchItemLoader from '@Components/Loaders/SearchItemLoader';

import styles from './SearchItemsContentLoader.module.scss';

interface SearchItemsContentLoaderProps {
  count: number;
  gridSize: number;
}

const SearchItemsContentLoader: React.FunctionComponent<SearchItemsContentLoaderProps> = ({ count, gridSize }) => {
  return (
    <div className={styles.wrapper}>
      <div className={gridSize > 3 ? styles.content4 : styles.content3}>
        {Array.from({ length: count }, (_, index) => (
          <SearchItemLoader key={index} />
        ))}
      </div>
    </div>
  );
};

export default SearchItemsContentLoader;
